'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _BoardTitle = require('../header/BoardTitle');

var _BoardTitle2 = _interopRequireDefault(_BoardTitle);

var _MobilePageStats = require('./MobilePageStats');

var _MobilePageStats2 = _interopRequireDefault(_MobilePageStats);

require('./MobileBoardHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var MobileBoardHeader = function MobileBoardHeader(props) {
    return _react2.default.createElement(
        'div',
        { className: 'MobileBoardHeader' },
        _react2.default.createElement('div', { className: 'header-left' }),
        _react2.default.createElement(
            'div',
            { className: 'header-center' },
            _react2.default.createElement(_BoardTitle2.default, props)
        ),
        _react2.default.createElement(
            'div',
            { className: 'header-right' },
            _react2.default.createElement(_MobilePageStats2.default, props)
        )
    );
};

// Styles


// Components


MobileBoardHeader.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isEditable: _propTypes2.default.bool,
    getDocumentElementSizes: _propTypes2.default.func,
    elementFilter: _propTypes2.default.object
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(MobileBoardHeader);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/MobileBoardHeader.js
// module id = 2201
// module chunks = 0